export const SIPCENTRIC = 'SIPCENTRIC'
export const CUSTOMERS = 'SIPCENTRIC_CUSTOMERS'
export const CUSTOMER = 'SIPCENTRIC_CUSTOMER'
export const CREATE_CUSTOMER_PBX = 'CREATE_CUSTOMER_PBX'
export const UPDATE_CUSTOMER_PBX = 'UPDATE_CUSTOMER_PBX'
export const PROVISION_CUSTOMER_PBX = 'PROVISION_CUSTOMER_PBX'
export const DISABLE_PBX = 'DISABLE_PBX'

export default {
    SIPCENTRIC,
    CUSTOMERS,
    CUSTOMER,
    CREATE_CUSTOMER_PBX,
    UPDATE_CUSTOMER_PBX,
    PROVISION_CUSTOMER_PBX,
    DISABLE_PBX
}
